import React, { useState } from "react";

export default function InteractivePlaneIcon({ aircraft }) {
  const [activeHotspot, setActiveHotspot] = useState(null);

  const handleEngineHover = (isEntering) => {
    setActiveHotspot(isEntering ? "engine" : null);
  };

  const handleWingtipHover = (isEntering) => {
    setActiveHotspot(isEntering ? "wingtip" : null);
  };

  const handleDimensionsHover = (isEntering) => {
    setActiveHotspot(isEntering ? "dimensions" : null);
  };

  return (
    <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 xl:gap-8 w-full">
      <div className="relative w-full md:w-auto flex justify-center flex-shrink-0">
        <svg viewBox="0 0 246 271" className="w-40 sm:w-48 md:w-44 xl:w-52 h-auto">

          {/* --- Engines Hotspots (Below main body via z-index simulation) --- */}
          {/* Left engines */}
          <g
            onMouseEnter={() => handleEngineHover(true)}
            onMouseLeave={() => handleEngineHover(false)}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
          >
            <polygon
              points="0.6833,36.5297 0.5012,3.4071 3.5328,0.5864 19.0309,0.5011 22.0585,3.5371 22.2393,36.4112"
              fill={activeHotspot === "engine" ? "#4f46e5" : "#e5e7eb"}
              fillOpacity={activeHotspot === "engine" ? "0.8" : "0.5"}
              stroke={activeHotspot === "engine" ? "#4f46e5" : "#6b7280"}
              strokeWidth="1.5"
              transform={aircraft.model === "Airbus A380-800" ? "translate(30, 120)" : "translate(60, 100)"}
            />
          </g>

          {aircraft.model === "Airbus A380-800" && (
            <g
              onMouseEnter={() => handleEngineHover(true)}
              onMouseLeave={() => handleEngineHover(false)}
              style={{ cursor: "pointer", transition: "all 0.2s" }}
            >
              <polygon
                points="0.6833,36.5297 0.5012,3.4071 3.5328,0.5864 19.0309,0.5011 22.0585,3.5371 22.2393,36.4112"
                fill={activeHotspot === "engine" ? "#4f46e5" : "#e5e7eb"}
                fillOpacity={activeHotspot === "engine" ? "0.8" : "0.5"}
                stroke={activeHotspot === "engine" ? "#4f46e5" : "#6b7280"}
                strokeWidth="1.5"
                transform="translate(60, 100)"
              />
            </g>
          )}

          {/* Right engines */}
          {aircraft.model === "Airbus A380-800" && (
            <g
              onMouseEnter={() => handleEngineHover(true)}
              onMouseLeave={() => handleEngineHover(false)}
              style={{ cursor: "pointer", transition: "all 0.2s" }}
            >
              <polygon
                points="0.6833,36.5297 0.5012,3.4071 3.5328,0.5864 19.0309,0.5011 22.0585,3.5371 22.2393,36.4112"
                fill={activeHotspot === "engine" ? "#4f46e5" : "#e5e7eb"}
                fillOpacity={activeHotspot === "engine" ? "0.8" : "0.5"}
                stroke={activeHotspot === "engine" ? "#4f46e5" : "#6b7280"}
                strokeWidth="1.5"
                transform="translate(165, 100)"
              />
            </g>
          )}

          <g
            onMouseEnter={() => handleEngineHover(true)}
            onMouseLeave={() => handleEngineHover(false)}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
          >
            <polygon
              points="0.6833,36.5297 0.5012,3.4071 3.5328,0.5864 19.0309,0.5011 22.0585,3.5371 22.2393,36.4112"
              fill={activeHotspot === "engine" ? "#4f46e5" : "#e5e7eb"}
              fillOpacity={activeHotspot === "engine" ? "0.8" : "0.5"}
              stroke={activeHotspot === "engine" ? "#4f46e5" : "#6b7280"}
              strokeWidth="1.5"
              transform={aircraft.model === "Airbus A380-800" ? "translate(200, 120)" : "translate(165, 100)"}
            />
          </g>


          {/* --- Plane Body --- */}
          <path
            d="M122.1321,0.502c0.4095,0.0083 0.8168,0.0419 1.2212,0.1002c0.2181,-0.0189 0.4369,-0.0306 0.6564,-0.0351c10.084,-0.2035 17.761,15.0691 17.1619,34.125h0l-0.2397,57.2588l101.9082,62.2034l2.6943,15.8472l-104.8679,-14.6447l-0.2561,61.1651l-0.3152,-0.0013l43.3636,34.8179l-0.0623,12.155l-51.0125,-6.5343c-0.4035,1.949 -0.9815,3.8692 -1.7517,5.7042c-1.9374,4.616 -4.3788,7.108 -6.8381,7.7619l0,0.1096c-0.1508,0.0035 -0.3019,0.0002 -0.4532,-0.0099c-0.3318,0.0579 -0.6633,0.0827 -0.9935,0.075l0,-0.2399c-2.4592,-0.6539 -4.9007,-3.1459 -6.8381,-7.7619c-0.7702,-1.8351 -1.3482,-3.7552 -1.7517,-5.7043l-51.0125,6.5343l-0.0623,-12.1549l43.3636,-34.8179l-0.3152,0.0013l-0.256,-61.1651l-104.8679,14.6447l2.6943,-15.8472l101.9082,-62.2034l-0.2397,-57.2588h0c-0.5991,-19.0558 7.0779,-34.3284 17.1619,-34.125z"
            fill="#ffffff"
            stroke="#000000"
            strokeWidth="1.5"
          />

          {/* --- Cabin / Fuselage Hotspot --- */}
          <g
            onMouseEnter={() => setActiveHotspot("fuselage")}
            onMouseLeave={() => setActiveHotspot(null)}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
          >
            <rect
              x="105"
              y="26"
              width="36"
              height="191"
              fill={activeHotspot === "fuselage" ? "#c7d2fe" : "transparent"}
              fillOpacity="0.6"
              stroke={activeHotspot === "fuselage" ? "#4f46e5" : "transparent"}
              strokeWidth="2"
            />
          </g>

          
          {/* --- Wingtips Hotspots --- */}
          <g
            onMouseEnter={() => handleWingtipHover(true)}
            onMouseLeave={() => handleWingtipHover(false)}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
          >
            <polygon
              points="0.6074,28.0536 3.3017,12.2064 21.8398,0.891 21.8398,25.0885"
              fill={activeHotspot === "wingtip" ? "#4f46e5" : "transparent"}
              fillOpacity="0.6"
              stroke={activeHotspot === "wingtip" ? "#4f46e5" : "transparent"}
              strokeWidth="2"
              transform="translate(0, 142)"
            />
          </g>

          <g
            onMouseEnter={() => handleWingtipHover(true)}
            onMouseLeave={() => handleWingtipHover(false)}
            style={{ cursor: "pointer", transition: "all 0.2s" }}
          >
            <polygon
              points="21.7324,28.0536 19.0381,12.2064 0.5,0.891 0.5,25.0885"
              fill={activeHotspot === "wingtip" ? "#4f46e5" : "transparent"}
              fillOpacity="0.6"
              stroke={activeHotspot === "wingtip" ? "#4f46e5" : "transparent"}
              strokeWidth="2"
              transform="translate(224, 142)"
            />
          </g>
        </svg>

        {/* Wingspan measurement (horizontal) */}
        <div className={`absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-6 md:-translate-y-8 flex items-center gap-1 md:gap-2 transition-all ${
          activeHotspot === "dimensions" ? "opacity-100" : "opacity-40"
        }`}>
          <div className={`h-px w-4 md:w-8 transition-colors ${
            activeHotspot === "dimensions" ? "bg-indigo-600" : "bg-gray-400"
          }`}></div>
          <span className={`text-[10px] md:text-xs font-semibold whitespace-nowrap transition-colors ${
            activeHotspot === "dimensions" ? "text-indigo-600" : "text-gray-500"
          }`}>
            {aircraft.wingspan}m
          </span>
          <div className={`h-px w-4 md:w-8 transition-colors ${
            activeHotspot === "dimensions" ? "bg-indigo-600" : "bg-gray-400"
          }`}></div>
        </div>

        {/* Length measurement (vertical) */}
        <div className={`absolute right-0 md:right-auto md:left-full top-1/2 transform -translate-x-2 md:translate-x--5 -translate-y-1/2 flex flex-col items-center gap-1 pr-2 md:pr-0 md:pl-3 transition-all ${
        activeHotspot === "dimensions" ? "opacity-100" : "opacity-40"
        }`}>
          <div className={`w-px h-4 md:h-8 transition-colors ${
            activeHotspot === "dimensions" ? "bg-indigo-600" : "bg-gray-400"
          }`}></div>
          <span className={`text-[10px] md:text-xs font-semibold whitespace-nowrap writing-mode-vertical transition-colors ${
            activeHotspot === "dimensions" ? "text-indigo-600" : "text-gray-500"
          }`} style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}>
            {aircraft.length}m
          </span>
          <div className={`w-px h-4 md:h-8 transition-colors ${
            activeHotspot === "dimensions" ? "bg-indigo-600" : "bg-gray-400"
          }`}></div>
        </div>
      </div>

      {/* --- Info Boxes --- */}
      <div className="w-full md:flex-1 md:min-w-0 space-y-2 md:space-y-2.5">
        {/* Dimensions */}
        <div
          className={`p-2 md:p-2.5 rounded-lg border-2 transition-all cursor-pointer ${
            activeHotspot === "dimensions"
              ? "bg-indigo-50 border-indigo-500 shadow-sm"
              : "bg-gray-50 border-gray-200"
          }`}
          onMouseEnter={() => handleDimensionsHover(true)}
          onMouseLeave={() => handleDimensionsHover(false)}
        >
          <p className="text-[10px] md:text-xs text-gray-500 font-semibold mb-0.5">DIMENSIONS</p>
          <p className="text-xs md:text-sm font-bold text-gray-800">{aircraft.wingspan}m × {aircraft.length}m</p>
        </div>

        {/* Engines */}
        <div
          className={`p-2 md:p-2.5 rounded-lg border-2 transition-all cursor-pointer ${
            activeHotspot === "engine"
              ? "bg-indigo-50 border-indigo-500 shadow-sm"
              : "bg-gray-50 border-gray-200"
          }`}
          onMouseEnter={() => setActiveHotspot("engine")}
          onMouseLeave={() => setActiveHotspot(null)}
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1 min-w-0">
              <p className="text-[10px] md:text-xs text-gray-500 font-semibold mb-0.5">ENGINE TYPE</p>
              <p className="text-xs md:text-sm font-bold text-gray-800 truncate">{aircraft.engineType}</p>
            </div>
            <div className="flex flex-col gap-1 flex-shrink-0">
              {aircraft.model === "Airbus A380-800" && (
                <span className="bg-purple-600 text-white text-[9px] md:text-[10px] px-1.5 py-0.5 rounded-full font-semibold whitespace-nowrap leading-tight">
                  4 Engines
                </span>
              )}
              {aircraft.serratedNacelles === true && (
                <span className="bg-indigo-600 text-white text-[9px] md:text-[10px] px-1.5 py-0.5 rounded-full font-semibold whitespace-nowrap leading-tight">
                  Serrated
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Wingtips */}
        <div
          className={`p-2 md:p-2.5 rounded-lg border-2 transition-all cursor-pointer ${
            activeHotspot === "wingtip"
              ? "bg-indigo-50 border-indigo-500 shadow-sm"
              : "bg-gray-50 border-gray-200"
          }`}
          onMouseEnter={() => setActiveHotspot("wingtip")}
          onMouseLeave={() => setActiveHotspot(null)}
        >
          <p className="text-[10px] md:text-xs text-gray-500 font-semibold mb-0.5">WINGTIP DESIGN</p>
          <p className="text-xs md:text-sm font-bold text-gray-800">{aircraft.wingtips}</p>
        </div>

        {/* Capacity */}
        <div
          className={`p-2 md:p-2.5 rounded-lg border-2 transition-all cursor-pointer ${
            activeHotspot === "fuselage"
              ? "bg-indigo-50 border-indigo-500 shadow-sm"
              : "bg-gray-50 border-gray-200"
          }`}
          onMouseEnter={() => setActiveHotspot("fuselage")}
          onMouseLeave={() => setActiveHotspot(null)}
        >
          <p className="text-[10px] md:text-xs text-gray-500 font-semibold mb-0.5">SEATING CAPACITY</p>
          <p className="text-xs md:text-sm font-bold text-gray-800">{aircraft.numberOfSeats} seats</p>
        </div>

        {/* Cruising Speed */}
        <div className="p-2 md:p-2.5 rounded-lg border-2 bg-gray-50 border-gray-200">
          <p className="text-[10px] md:text-xs text-gray-500 font-semibold mb-0.5">CRUISING SPEED</p>
          <p className="text-xs md:text-sm font-bold text-gray-800">Mach {aircraft.cruisingSpeed}</p>
        </div>
      </div>
    </div>
  );
}